import { translations } from '@loyalty/translations';

export const PARENT_TYPE = 'parentType';

export function markChildrenWithParentType(element: any): void {
  element.components.forEach((component: any) => (component[PARENT_TYPE] = element.type));
}

type Element = { i18nAttributes: { [locale: string]: { [prop: string]: any } } };

export function translateAttributes(
  element: Element,
  destinationLocales: string[],
  fallback?: { property: string; translationKey: string },
): void {
  const { i18nAttributes } = element;
  if (i18nAttributes) {
    const newI18nAttributes: Record<string, any> = {};

    if (fallback) {
      // TODO stop using translations, use i18n instead which should have access to all translations
      for (const locale of destinationLocales) {
        newI18nAttributes[locale] = i18nAttributes[locale] || {
          [fallback.property]:
            (translations as any)[locale]?.[fallback.translationKey] ||
            (translations as any)['en']?.[fallback.translationKey],
        };
      }
    } else {
      for (const locale of destinationLocales) {
        newI18nAttributes[locale] =
          i18nAttributes[locale] ||
          i18nAttributes['en'] ||
          i18nAttributes[Object.keys(i18nAttributes)[0]];
      }
    }

    element.i18nAttributes = newI18nAttributes;
  }
}
